import axios from "axios";
import Endpoint from "./endpoints";
import { getToken, setToken, getUser } from "./auth";

const axiosInstance = axios.create({
  baseURL: Endpoint.baseAddr,
});

const CancelToken = axios.CancelToken;
let cancelGetCheckinImg;
let cancelGetCheckoutImg;
let cancelGetExtraImg = [];

export default axiosInstance;

// função que converte um array no formato [{field1, value1}, {field2, value2}]
// para uma string no formato "field1=value1,field2=value2"
export function filtersArrayToQueryString(array) {
  console.log("Array", array);
  const a = array
    .map((item) => {
      console.log("Item", item);
      return `${item.field}:${item.value}`;
    })
    .join(",");

  console.log("A", a);
  return a;
}

export const api = {
  login: async (username, password) => {
    const { data } = await axiosInstance.post(Endpoint.login, {
      username,
      password,
    });
    setToken(data.jwt);
    return data;
  },

  loadUser: async () => {
    const token = getToken();
    const username = getUser();
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const { data } = await axiosInstance.get(Endpoint.usuarios + username);
    return data;
  },

  getUserId: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.usuarios + id);
    return data;
  },

  getUsers: async () => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.usuarios);
    return data;
  },

  postUser: async (email, nome, senha, role, status) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.post(Endpoint.register, {
      email,
      nome,
      senha,
      role,
      status,
    });
    return data;
  },

  putUser: async (email, nome, senha, role, status, rotas, lojas) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.put(Endpoint.usuarios, {
      email,
      nome,
      senha,
      role,
      status,
      rotas,
      lojas,
    });
    return data;
  },

  getStoreById: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.lojas + id);
    return data;
  },

  getStores: async () => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.lojas);
    return data;
  },

  getLogs: async (
    page = null,
    size = null,
    sortBy = null,
    sortDirection = null,
    filters = []
  ) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;

    console.log("Params", {
      page: page,
      size: size,
      sortBy: sortBy,
      sortOrder: sortDirection,
      filters: filters.length > 0 ? filtersArrayToQueryString(filters) : null,
    });

    const { data } = await axiosInstance.get(Endpoint.logs + "filter", {
      params: {
        page: page,
        size: size,
        sortBy: sortBy,
        sortOrder: sortDirection,
        filters: filters.length > 0 ? filtersArrayToQueryString(filters) : null,
      },
    });

    return data;
  },

  postStore: async (nome, endereco, rotas, produtos, admins) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.post(Endpoint.lojas, {
      nome,
      endereco,
      rotas,
      produtos,
      admins,
    });
    return data;
  },

  putStore: async (id, nome, endereco, rotas, produtos, admins) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.put(Endpoint.lojas, {
      id,
      nome,
      endereco,
      rotas,
      produtos,
      admins,
    });
    return data;
  },

  getCompProducts: async () => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.pc);
    return data;
  },

  getCompProductsById: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.pc + id);
    return data;
  },

  postCompProduct: async (nome) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.post(Endpoint.pc, { nome });
    return data;
  },

  putCompProduct: async (id, nome, proprios) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.put(Endpoint.pc, {
      id,
      nome,
      proprios,
    });
    return data;
  },

  getOwnProducts: async () => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.pp);
    return data;
  },

  getOwnProductById: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.pp + id);
    return data;
  },

  postOwnProduct: async (nome, competidores, lojas) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.post(Endpoint.pp, {
      nome,
      competidores,
      lojas,
    });
    return data;
  },

  putOwnProduct: async (id, nome, competidores, lojas) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.put(Endpoint.pp, {
      id,
      nome,
      competidores,
      lojas,
    });
    return data;
  },

  getRoutes: async () => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.rotas);
    return data;
  },

  getRouteById: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.rotas + id);
    return data;
  },

  postRoute: async (nome, usuarios, lojas) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.post(Endpoint.rotas, {
      nome,
      usuarios,
      lojas,
    });
    return data;
  },

  putRoute: async (id, nome, usuarios, lojas) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.put(Endpoint.rotas, {
      id,
      nome,
      usuarios,
      lojas,
    });
    return data;
  },

  getVisits: async (
    pageNo = 0,
    pageSize = 0,
    sortBy = "id",
    search = undefined
  ) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const params = {
      pageNo,
      pageSize,
      sortBy,
      // search,
    };
    const { data } = await axiosInstance.get(Endpoint.visitas, { params });
    return data;
  },

  getVisitsByDate: async (date) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.visitas, {
      params: {
        startDate: date,
        endDate: `${date.slice(0, 11)}23:59:59`,
      },
    });
    return data;
  },

  getVisitsByDateRange: async (startDate, endDate) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(Endpoint.visitas, {
      params: {
        startDate,
        endDate: `${endDate.slice(0, 11)}23:59:59`,
      },
    });
    return data;
  },

  getCheckinImg: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(
      Endpoint.visitas + "checkin/" + id,
      {
        responseType: "arraybuffer",
        cancelToken: new CancelToken((c) => {
          cancelGetCheckinImg = c;
        }),
      }
    );
    return data;
  },

  getCheckoutImg: async (id) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(
      Endpoint.visitas + "checkout/" + id,
      {
        responseType: "arraybuffer",
        cancelToken: new CancelToken((c) => {
          cancelGetCheckoutImg = c;
        }),
      }
    );
    return data;
  },

  getExtraImg: async (id, imgId) => {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${getToken()}`;
    const { data } = await axiosInstance.get(
      Endpoint.visitas + "checkout/" + id + "/" + imgId,
      {
        responseType: "arraybuffer",
        cancelToken: new CancelToken((c) => {
          cancelGetExtraImg.push(c);
        }),
      }
    );
    return data;
  },

  cancelRequest: async () => {
    if (cancelGetCheckinImg)
      cancelGetCheckinImg("Operação cancelada pelo usuário");
    if (cancelGetCheckoutImg)
      cancelGetCheckoutImg("Operação cancelada pelo usuário");
    if (cancelGetExtraImg) {
      cancelGetExtraImg.map((func, item) => {
        func("Imagem extra cancelada :" + item);
        return null;
      });
    }
    cancelGetExtraImg = [];
  },
};
